/**
 *
 * FlashCardDetail
 *
 */

import { mapState, mapMutations } from 'vuex';

import { QuestionFontSizeMixin } from '@/scripts/FlashCard/FlashCardDetail/mixins/QuestionFontSizeMixin';

export default {
  name: 'FlashCardSide',

  mixins: [QuestionFontSizeMixin],

  props: {
    p_flashCardBodyContent: {
      type: String,
      default: () => '',
    },
  },

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardInfo: 'flashCardInfo',
      ms_flashCardList: 'flashCardList',
      ms_idxCard: 'idxCard',
      ms_flashCardDetail: 'flashCardDetail',
      ms_isShownAnswerTransition: 'isShownAnswerTransition',
      ms_isFlashCardReported: 'isFlashCardReported',
    }),
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_MODAL_CARD_TYPE: 'SET_MODAL_CARD_TYPE',
    }),

    toggleReport() {
      this.mm_SET_MODAL_CARD_TYPE('report');
    },
  },
};
